import * as _fs3 from "fs";

var _fs2 = "default" in _fs3 ? _fs3.default : _fs3;

import * as _gensync3 from "gensync";

var _gensync2 = "default" in _gensync3 ? _gensync3.default : _gensync3;

var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.stat = exports.readFile = void 0;

  function _fs() {
    const data = _fs2;

    _fs = function () {
      return data;
    };

    return data;
  }

  function _gensync() {
    const data = _gensync2;

    _gensync = function () {
      return data;
    };

    return data;
  }

  const readFile = _gensync()({
    sync: _fs().readFileSync,
    errback: _fs().readFile
  });

  exports.readFile = readFile;

  const stat = _gensync()({
    sync: _fs().statSync,
    errback: _fs().stat
  });

  exports.stat = stat;
  return exports;
}